var CryptoJS = require("crypto-js");

function decrypt(ciphertext) {
  const PUB_KEY = process.env.REACT_APP_PUBKEY;
  var bytes = CryptoJS.AES.decrypt(ciphertext, PUB_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}

module.exports = decrypt;